"use client";

import type { ReactNode } from "react";
import { Toggle } from "@/shared/ui/buttons/toggle";
import { cn } from "@/shared/lib/utils";

interface BoardChipProps {
  pressed: boolean;
  onPressedChange: () => void;
  icon?: ReactNode;
  children: ReactNode;
  /** Полное название, когда на чипе код (сервер EUW1 → «Europe West»). */
  title?: string;
}

/** Чип фильтра доски LFG: иконка, затем подпись; выбранный — в акценте highlight. */
export function BoardChip({ pressed, onPressedChange, icon, children, title }: BoardChipProps) {
  return (
    <Toggle
      pressed={pressed}
      onPressedChange={onPressedChange}
      title={title}
      className={cn(
        "h-8 min-w-0 justify-center gap-1.5 rounded-lg border border-border bg-muted/40 px-2 font-logo text-xs font-normal text-muted-foreground",
        "hover:bg-muted hover:text-foreground",
        "data-[state=on]:border-highlight-border data-[state=on]:bg-highlight-soft data-[state=on]:text-highlight",
      )}
    >
      {icon}
      <span className="truncate">{children}</span>
    </Toggle>
  );
}
